'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stKeyValueDisplay
 * @description
 * # stKeyValueDisplay
 * Displays a value, applying specific formatting (like currency) based on its key.
 *
 * @param {string} itemKey The key to determine formatting.
 * @param {*} itemValue The value to display.
 * @param {string} [linkUrl] Optional: If provided, the value will be wrapped in an <a> tag.
 *                         (Note: ng-switch creates its own scope, so complex ng-href might be tricky without care)
 */
angular.module('360StoreAngularApp')
	.component('stKeyValueDisplay', {
		template: `
			<span ng-switch="$ctrl.itemKey">
				<a ng-switch-when="orderId" ng-click="$root.editOrderModalById($ctrl.itemValue)">{{$ctrl.itemValue}}</a>
				<a ng-switch-when="cartItemId" ng-click="$root.editOrderModalByCartItemId($ctrl.itemValue)">{{$ctrl.itemValue}}</a>
				<span ng-switch-when="revenue_30">{{$ctrl.itemValue | currency : '$'}}</span>
				<span ng-switch-when="revenue_90">{{$ctrl.itemValue | currency : '$'}}</span>
				<span ng-switch-when="revenue_365">{{$ctrl.itemValue | currency : '$'}}</span>
				<span ng-switch-when="revenue_all">{{$ctrl.itemValue | currency : '$'}}</span>
				<span ng-switch-when="count_30">{{$ctrl.itemValue | number}}</span>
				<span ng-switch-when="count_90">{{$ctrl.itemValue | number}}</span>
				<span ng-switch-when="count_365">{{$ctrl.itemValue | number}}</span>
				<span ng-switch-when="count_all">{{$ctrl.itemValue | number}}</span>
				<span ng-switch-when="timestamp">{{$ctrl.itemValue | date : 'medium'}}</span>
				<span ng-switch-when="lastLicenseCheck">{{$ctrl.itemValue | date : 'medium'}}</span>
				<span ng-switch-when="whenConnected">{{$ctrl.itemValue | date : 'medium'}}</span>
				<span ng-switch-when="whenDisconnected">{{$ctrl.itemValue | date : 'medium'}}</span>
				<span ng-switch-default="">{{$ctrl.itemValue}}</span>
			</span>
    `,
		bindings: {
			itemKey: '<',  // One-way binding for the key
			itemValue: '<', // One-way binding for the value
			isNumeric: '<'
		},
	});
